<template>
    <BaseTemplate app-name="Whatsapp" page-title="">
      <template #content>
        <div class="flex h-screen bg-gray-50 dark:bg-gray-900">
          <!-- Sidebar Menu -->
          <aside class="w-64 bg-white dark:bg-gray-800 shadow-lg border-r border-gray-200 dark:border-gray-700">
            <div class="flex flex-col h-full">
              <!-- Sidebar Header -->
              <div class="p-6 border-b border-gray-200 dark:border-gray-700">
                <h2 class="text-xl font-bold text-gray-800 dark:text-white">Faturamento</h2>
              </div>
              
              <!-- Navigation Menu -->
              <nav class="flex-1 px-4 py-6 space-y-2 overflow-y-auto">
                <!-- Active Menu Item -->
                <div :class="currentView === 'tabelas' ? 'bg-blue-500 text-white' : 'text-gray-700 dark:text-gray-300 hover:bg-blue-50 dark:hover:bg-blue-900/20 hover:text-blue-600 dark:hover:text-blue-400'" 
                   @click="navegarPara('tabelas')" 
                     class="flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors duration-200 cursor-pointer">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"></path>
                  </svg>
                  <span class="font-medium">Tabelas</span>
                </div>
                
                <!-- Regular Menu Items -->
                <div :class="currentView === 'gerarFaturas' ? 'bg-blue-500 text-white' : 'text-gray-700 dark:text-gray-300 hover:bg-blue-50 dark:hover:bg-blue-900/20 hover:text-blue-600 dark:hover:text-blue-400'" 
                   @click="navegarPara('gerarFaturas')" 
                     class="flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors duration-200 cursor-pointer">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                  </svg>
                  <span>Gerar Faturas</span>
                </div>
                
                <div :class="currentView === 'faturasGeradas' ? 'bg-blue-500 text-white' : 'text-gray-700 dark:text-gray-300 hover:bg-blue-50 dark:hover:bg-blue-900/20 hover:text-blue-600 dark:hover:text-blue-400'" 
                   @click="navegarPara('faturasGeradas')" 
                     class="flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors duration-200 cursor-pointer">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"></path>
                  </svg>
                  <span>Faturas Geradas</span>
                </div>
                
                <div :class="currentView === 'procurarConta' ? 'bg-blue-500 text-white' : 'text-gray-700 dark:text-gray-300 hover:bg-blue-50 dark:hover:bg-blue-900/20 hover:text-blue-600 dark:hover:text-blue-400'" 
                   @click="navegarPara('procurarConta')" 
                     class="flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors duration-200 cursor-pointer">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                  </svg>
                  <span>Procurar Conta</span>
                </div>
                
              <div :class="currentView === 'recalcularPeriodo' ? 'bg-blue-500 text-white' : 'text-gray-700 dark:text-gray-300 hover:bg-blue-50 dark:hover:bg-blue-900/20 hover:text-blue-600 dark:hover:text-blue-400'" 
                   @click="navegarPara('recalcularPeriodo')" 
                   class="flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors duration-200 cursor-pointer">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                  </svg>
                  <span>Recalcular Período</span>
                </div>
                
             <!--   <div :class="currentView === 'recursoGlosa' ? 'bg-blue-500 text-white' : 'text-gray-700 dark:text-gray-300 hover:bg-blue-50 dark:hover:bg-blue-900/20 hover:text-blue-600 dark:hover:text-blue-400'" 
                   @click="navegarPara('recursoGlosa')" 
                     class="flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors duration-200 cursor-pointer">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                  <span>Recurso Glosa</span>
                </div> -->
                
              <div :class="currentView === 'auditoriaCalculoConta' ? 'bg-blue-500 text-white' : 'text-gray-700 dark:text-gray-300 hover:bg-blue-50 dark:hover:bg-blue-900/20 hover:text-blue-600 dark:hover:text-blue-400'" 
                   @click="navegarPara('auditoriaCalculoConta')" 
                     class="flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors duration-200 cursor-pointer">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v6a2 2 0 002 2h2m0 0h2m-2 0v6a2 2 0 002 2h6a2 2 0 002-2v-6a2 2 0 00-2-2h-2m-2 0V9a2 2 0 00-2-2H9z"></path>
                  </svg>
                  <span>Auditoria de Cálculo de Conta</span>
                </div>

                <!-- Nova aba BPA -->
                <div :class="currentView === 'bpa' ? 'bg-blue-500 text-white' : 'text-gray-700 dark:text-gray-300 hover:bg-blue-50 dark:hover:bg-blue-900/20 hover:text-blue-600 dark:hover:text-blue-400'"
                     @click="navegarPara('bpa')"
                     class="flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors duration-200 cursor-pointer">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6M9 16h6M7 20h10a2 2 0 002-2V6a2 2 0 00-2-2H9l-2 2H7a2 2 0 00-2 2v12z"></path>
                  </svg>
                  <span>BPA/APAC</span>
                </div>
              </nav>
            </div>
          </aside>
  
          <!-- Main Content Area -->
          <main class="flex-1 flex flex-col overflow-hidden">
              <!-- Content Area -->
              <div class="flex-1 overflow-y-auto">
            <!-- Loading State -->
            <div v-if="isLoading" class="flex items-center justify-center h-full">
              <Loader2 class="w-12 h-12 text-blue-500 animate-spin" />
            </div>
            
            <!-- Router View para renderizar os componentes filhos -->
            <router-view 
              v-show="!isLoading"
              @open-modal="openModal"
              @close-modal="closeModal"
              @show-banner="showBannerMessage"
            />
            </div>
          </main>
      </div>

            <!-- Banner Message -->
      <BannerMessage 
        v-if="showBanner" 
        :message="bannerMessage" 
        :type="bannerType" 
        @close="closeBannerMessage" 
      />
    </template>
    </BaseTemplate>
  </template>
  
  <script setup>
import { ref, onMounted, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { Loader2 } from 'lucide-vue-next'
import BaseTemplate from '../templates/BaseTemplate.vue'
import BannerMessage from '../../components/BannerMessage.vue'

// Router e Route
const router = useRouter()
const route = useRoute()
  
  // Estado atual da view
  const currentView = ref('tabelas')
  const isLoading = ref(false)
  
  // Banner Message
  const showBanner = ref(false)
  const bannerMessage = ref('')
  const bannerType = ref('success')
  
// Funções de navegação
const navegarPara = async (view) => {
  isLoading.value = true
  currentView.value = view
  
  // Atualizar a URL para refletir a view atual
  const routeMap = {
    'tabelas': '/faturamento/tabelas',
    'gerarFaturas': '/faturamento/gerar-faturas',
    'faturasGeradas': '/faturamento/faturas-geradas',
    'procurarConta': '/faturamento/procurar-conta',
    'recalcularPeriodo': '/faturamento/recalcular-periodo',
    'recursoGlosa': '/faturamento/recurso-glosa',
    'auditoriaCalculoConta': '/faturamento/auditoria-calculo-conta',
    'bpa': '/faturamento/bpa'
  }
  
  const targetRoute = routeMap[view]
  if (targetRoute) {
    try {
      await router.push(targetRoute)
    } finally {
      // Pequeno delay para garantir que a transição seja visível
      setTimeout(() => {
        isLoading.value = false
      }, 300)
    }
  } else {
    isLoading.value = false
  }
}

// Funções dos modais (mantidas para compatibilidade)
      const openModal = async (modalName) => {
  // Implementar se necessário
  console.log('Modal aberto:', modalName)
      }
  
  const closeModal = () => {
  // Implementar se necessário
  console.log('Modal fechado')
}

  // Funções para Banner Message
  const showBannerMessage = (message, type = 'success') => {
  console.log('DEBUG: Mostrando banner message:', { message, type })
    bannerMessage.value = message
    bannerType.value = type
    showBanner.value = true
  
  // Auto-hide após 5 segundos para mensagens de sucesso
  if (type === 'success') {
    setTimeout(() => {
      if (showBanner.value && bannerMessage.value === message) {
        closeBannerMessage()
      }
    }, 5000)
  }
  }

    const closeBannerMessage = () => {
  console.log('DEBUG: Fechando banner message')
    showBanner.value = false
  }

// Watcher para sincronizar view com rota
watch(() => route.path, (newPath) => {
  const pathToView = {
    '/faturamento/tabelas': 'tabelas',
    '/faturamento/gerar-faturas': 'gerarFaturas',
    '/faturamento/faturas-geradas': 'faturasGeradas',
    '/faturamento/procurar-conta': 'procurarConta',
    '/faturamento/recalcular-periodo': 'recalcularPeriodo',
    '/faturamento/recurso-glosa': 'recursoGlosa',
    '/faturamento/auditoria-calculo-conta': 'auditoriaCalculoConta',
    '/faturamento/bpa': 'bpa'
  }
  
  const view = pathToView[newPath]
  if (view && view !== currentView.value) {
    currentView.value = view
  }
}, { immediate: true })

// Navigation guards para lidar com loading durante navegação via browser
router.beforeEach((to, from, next) => {
  if (to.path.startsWith('/faturamento/')) {
    isLoading.value = true
  }
  next()
})

router.afterEach(() => {
  // Pequeno delay para garantir que a transição seja visível
  setTimeout(() => {
    isLoading.value = false
  }, 300)
})

// Inicialização
onMounted(() => {
  // Definir view inicial baseada na rota atual
  const pathToView = {
    '/faturamento/tabelas': 'tabelas',
    '/faturamento/gerar-faturas': 'gerarFaturas',
    '/faturamento/faturas-geradas': 'faturasGeradas',
    '/faturamento/procurar-conta': 'procurarConta',
    '/faturamento/recalcular-periodo': 'recalcularPeriodo',
    '/faturamento/recurso-glosa': 'recursoGlosa',
    '/faturamento/auditoria-calculo-conta': 'auditoriaCalculoConta',
    '/faturamento/bpa': 'bpa'
  }
  
  const view = pathToView[route.path] || 'tabelas'
  currentView.value = view
})
    </script>
  
  <style>
  @import 'tailwindcss/base';
  @import 'tailwindcss/components';
  @import 'tailwindcss/utilities';
  </style>